export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'getting-started',
    name: '入门指南',
    description: 'http 91.com 平台快速入门教程，从零开始了解平台访问与基础操作',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'features',
    name: '功能教程',
    description: '深入了解 http 91.com 各项核心功能，掌握平台完整使用方法',
    icon: 'ri-apps-line',
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: 'http 91.com 使用过程中遇到的各类问题汇总与详细解答',
    icon: 'ri-question-answer-line',
  },
  {
    slug: 'updates',
    name: '最新动态',
    description: '跟踪 http 91.com 平台最新公告、版本更新与入口变更信息',
    icon: 'ri-flashlight-line',
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}